let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1xulB")).then(() => parcelRequire('8jV93'));